import { Reveal } from "@/components/Reveal";

const chunkRows = (items) => {
  const rows = [];
  let i = 0;
  let wide = false;
  while (i < items.length) {
    const size = wide ? 4 : 3;
    rows.push(items.slice(i, i + size));
    i += size;
    wide = !wide;
  }
  return rows;
};

export const HoneycombGrid = ({ images, size = "md:h-52 md:w-64 h-36 w-44" }) => (
  <div className="flex flex-col items-center gap-4 md:gap-6">
    {chunkRows(images).map((row, ri) => (
      <div key={ri} className="flex flex-wrap justify-center gap-4 md:gap-6">
        {row.map((img, ii) => (
          <Reveal key={img.url} delay={(ri + ii) * 0.06}>
            <div
              data-testid={`honeycomb-cell-${ri}-${ii}`}
              className={`group relative ${size} hex-clip bg-[#1F2937] p-[2px] shadow-lg shadow-royal/15 transition-all duration-500 hover:-translate-y-1 hover:shadow-2xl hover:shadow-gold/25`}
            >
              <div className="hex-clip h-full w-full overflow-hidden">
                <img src={img.url} alt={img.caption} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                <div className="absolute inset-0 flex items-end justify-center bg-gradient-to-t from-navy/80 via-transparent to-transparent pb-6 opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                  <span className="px-2 text-center font-jakarta text-[10px] font-bold uppercase tracking-widest text-white md:text-xs">{img.caption}</span>
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    ))}
  </div>
);
